export default {
  PLAYING: "playing",
  RECORDING: "recording",
  PAUSED_HAS_RECORDING: "pausedHasRecording",
  PAUSED_NO_RECORDING: "pausedNoRecording"
};
